export const ExcelColumnStylesConfig = {
  header: {
    font: { bold: true, color: { argb: 'FFFFFFFF' } }, // White font
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF000000' } }, // Black background
    alignment: { vertical: 'middle', horizontal: 'center' }, // Center alignment
  },
  ColumnName1: {
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFE0B2' } }, // Light orange
  },
  ColumnName2: {
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB2E0FF' } }, // Light blue
  },
  default: {
    font: { color: { argb: 'FF000000' } }, // Default black font
  },
};
